import { globalEntitlements } from '../utils/globalEntitlements';

export const CORPORATE_DOCS_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.corporateDocs.buyBox.bulletPoint1' },
          { title: 'productPage.corporateDocs.buyBox.bulletPoint2' },
          { title: 'productPage.corporateDocs.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.corporateDocs.buyBox.productName',
        interactService: {
          ctaType: 'internalCheckout',
          service: 'corporate_docs',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/kitchen-document-review-laptop.png',
      alt: 'productPage.corporateDocs.heroPicture.altText',
    },
    headline: 'productPage.corporateDocs.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.corporateDocs.page.subheader',
  },
  showCase: {
    title: 'productPage.corporateDocs.showCase.title',
    stylesItem: {
      bgrColorItem: 'grey',
    },
    items: [
      {
        image: '/s2/raster/service-agreement-mockup.png',
        name: 'productPage.corporateDocs.showCase.item1Title',
        alt: 'productPage.corporateDocs.showCase.itemAltText',
      },
      {
        image: '/s2/raster/amendment-agreement-mockup.png',
        name: 'productPage.corporateDocs.showCase.item2Title',
        alt: 'productPage.corporateDocs.showCase.itemAltText',
      },
      {
        image: '/s2/raster/banking-resolution-mockup.png',
        name: 'productPage.corporateDocs.showCase.item3Title',
        alt: 'productPage.corporateDocs.showCase.itemAltText',
      },
      {
        image: '/s2/raster/confidentiality-agreement-mockup.png',
        name: 'productPage.corporateDocs.showCase.item4Title',
        alt: 'productPage.corporateDocs.showCase.itemAltText',
      },
    ],
  },
  benefit: {
    title: 'productPage.corporateDocs.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/installmobilerounded.svg',
        title: 'productPage.corporateDocs.valueProp.propTitle1',
        description: 'productPage.corporateDocs.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/dashboardcustomizerounded.svg',
        title: 'productPage.corporateDocs.valueProp.propTitle2',
        description: 'productPage.corporateDocs.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/allinclusiverounded.svg',
        title: 'productPage.corporateDocs.valueProp.propTitle3',
        description: 'productPage.corporateDocs.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.corporateDocs.howItWorks.title',
    items: [
      {
        title: 'productPage.corporateDocs.howItWorks.step1',
        description: 'productPage.corporateDocs.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.corporateDocs.howItWorks.step2',
        description: 'productPage.corporateDocs.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.corporateDocs.howItWorks.step3',
        description: 'productPage.corporateDocs.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/couple-review-documents.png',
    alt: 'productPage.corporateDocs.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  whatsIncluded: {
    title: 'productPage.corporateDocs.whatsIncluded.title',
    items: [
      {
        title: 'productPage.corporateDocs.whatsIncluded.item1',
        description: 'productPage.corporateDocs.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.corporateDocs.whatsIncluded.item2',
        description: 'productPage.corporateDocs.whatsIncluded.item2ShortDescription',
      },
    ],
    image: '/s2/raster/partners-review-documents.png',
    alt: 'productPage.corporateDocs.whatsIncluded.altText',
    hasIcon: true,
    hasDivider: false,
    hasNumber: false,
    hasMobileImage: false,
  },
  faqs: {
    title: 'productPage.corporateDocs.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.corporateDocs.frequentlyAskedQuestions.faq1',
        answer: 'productPage.corporateDocs.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.corporateDocs.frequentlyAskedQuestions.faq2',
        answer: 'productPage.corporateDocs.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.corporateDocs.frequentlyAskedQuestions.faq3',
        answer: 'productPage.corporateDocs.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.corporateDocs.needAssistance.title',
    getInTouch: 'productPage.corporateDocs.needAssistance.getInTouch',
    actions: 'productPage.corporateDocs.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.corporateDocs.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .currentProductNotPurchased()
    .build(),
};
